console.log('init: jquery-js'); // eslint-disable-line no-console

const jQuery = require('jquery');
require('jquery-migrate');

module.exports = jQuery;
